import type { Editor } from '@tiptap/react';
import { useContext, useEffect } from 'react';
import { RicosContext } from 'ricos-context';

export const useJsdomWidthFix = (ref: HTMLDivElement | null, editor: Editor) => {
  const { jsdomMode } = useContext(RicosContext);

  useEffect(() => {
    if (jsdomMode && ref) {
      Object.defineProperty(ref, 'clientWidth', {
        get: () => 1000,
      });
    }
  }, [jsdomMode, ref]);

  useEffect(() => {
    editor.on('create', () => {
      if (jsdomMode) {
        Object.defineProperty(editor.view.dom, 'clientWidth', {
          get: () => 1000,
        });
      }
    });
  }, []);
};
